import { throwOnMissingReanimated } from "../external/reanimated/moduleWrapper";

// eslint-disable-next-line import/no-default-export
export default throwOnMissingReanimated;
